import axios from "axios"
import Swal from "sweetalert2"

// location.hostname === "localhost" || location.hostname === "127.0.0.1"
// console.log(location.hostname)

const api = axios.create({
  baseURL: 'backendiot'
  // baseURL: "http://localhost:3333/",
  // baseURL: "https://iotmonitor-api-hml.syskeeper.com.br/",
  // baseURL: "https://api-iotmonitor-sa-saopaulo-1.syskeeper.com.br/",
})

const PUBLIC_AUTH_PATHS = ["/user/login", "/user"]

let isHandlingUnauthorized = false

const getBearerToken = () => {
  const user = JSON.parse(localStorage.getItem("user") || "null")
  const token = user?.token || user?.accessToken
  if (!token) {
    return null
  }
  return token.startsWith("Bearer ") ? token : `Bearer ${token}`
}

const clearSession = () => {
  localStorage.removeItem("user")
  if (api?.defaults?.headers?.common) {
    delete api.defaults.headers.common.Authorization
  }
}

const shouldSkipUnauthorizedHandler = (config) => {
  const url = config?.url || ""
  return PUBLIC_AUTH_PATHS.some((path) => url.includes(path))
}

const token = getBearerToken()
if (token) {
  api.defaults.headers.common.Authorization = token
}

api.interceptors.request.use((config) => {
  const currentToken = getBearerToken()
  if (currentToken) {
    config.headers = config.headers || {}
    config.headers.Authorization = currentToken
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status
    const hadUser = !!localStorage.getItem("user")

    if (
      status === 401 &&
      hadUser &&
      !isHandlingUnauthorized &&
      !shouldSkipUnauthorizedHandler(error.config)
    ) {
      isHandlingUnauthorized = true
      clearSession()
      Swal.fire({
        icon: "warning",
        title: "Sessão expirada",
        text: "Sua sessão expirou. Faça login novamente.",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.href = "/"
      })
    }

    return Promise.reject(error)
  }
)
// location.hostname === "localhost" || location.hostname === "127.0.0.1"
// console.log(location.hostname)
//baseURL: 'http://localhost:3333/',
// const api = axios.create({

//   baseURL:
//   location.hostname === "localhost"
//   ? "https//iotmonitor-api-hml.syskeeper.com.br/"
//   : 'iotmonitor-api',

// });

export default api
